import { c as _c } from "react/compiler-runtime";
import type { FieldGroupErrorType } from '@/app/components/forms/field-group';
import { type CustomFormStyleConfig, getCustomFormStyle, helpTextStyled } from '@/app/components/forms/styles';
import type { Theme } from '@/app/types/styles/theme';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
export interface FieldGroupMessageType {
  /**
   * The message to display in the field message component.
   */
  message?: string;
  /**
   * If `showMaxLength = true` - Text / Max length will be displayed at the bottom right of the field group
   */
  showMaxLength?: boolean;
  /**
   * Current text length - It will be displayed only when `showMaxLength = true`
   */
  length?: number;
  /**
   * Max text length  - It will be displayed only when `showMaxLength = true`
   */
  maxLength?: number;
  /**
   * Theme styling
   */
  theme?: Theme;
}
interface FieldGroupMessageProps extends FieldGroupMessageType, FieldGroupErrorType {
  /**
   * Custom theme styling
   */
  customStyle?: CustomFormStyleConfig['fieldGroup'];
}
export const FieldGroupMessage = t0 => {
  const $ = _c(19);
  const {
    message,
    customStyle,
    length: t1,
    maxLength: t2,
    error: t3,
    theme: t4,
    showMaxLength: t5
  } = t0;
  const length = t1 === undefined ? 0 : t1;
  const maxLength = t2 === undefined ? 0 : t2;
  const error = t3 === undefined ? false : t3;
  const theme = t4 === undefined ? "light" : t4;
  const showMaxLength = t5 === undefined ? false : t5;
  const countText = `${length}/${maxLength}`;
  let t6;
  if ($[0] !== countText || $[1] !== customStyle?.message || $[2] !== error || $[3] !== length || $[4] !== maxLength || $[5] !== message || $[6] !== showMaxLength || $[7] !== theme) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const messageClass = cn(helpTextStyled({
        theme,
        error
      }), "text-caption transition-color", getCustomFormStyle(customStyle?.message, {
        error
      }));
      const shouldShowMessage = !!message;
      const shouldShowCount = showMaxLength && typeof length === "number" && typeof maxLength === "number";
      if (shouldShowMessage && shouldShowCount) {
        const t7 = cn("flex items-baseline gap-4", {
          "justify-end": showMaxLength && !message,
          "justify-between": showMaxLength && message
        }, messageClass);
        let t8;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
          t8 = createDataAttributes({
            test: "message"
          });
          $[9] = t8;
        } else {
          t8 = $[9];
        }
        let t9;
        if ($[10] !== message || $[11] !== t8) {
          t9 = <span {...t8}>{message}</span>;
          $[10] = message;
          $[11] = t8;
          $[12] = t9;
        } else {
          t9 = $[12];
        }
        let t10;
        if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
          t10 = createDataAttributes({
            test: "count"
          });
          $[13] = t10;
        } else {
          t10 = $[13];
        }
        let t11;
        if ($[14] !== countText || $[15] !== t10) {
          t11 = <span {...t10}>{countText}</span>;
          $[14] = countText;
          $[15] = t10;
          $[16] = t11;
        } else {
          t11 = $[16];
        }
        t6 = <div className={t7}>{t9}{t11}</div>;
        break bb0;
      }
      if (shouldShowMessage) {
        const t7 = cn("block", messageClass);
        let t8;
        if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
          t8 = createDataAttributes({
            test: "message"
          });
          $[17] = t8;
        } else {
          t8 = $[17];
        }
        t6 = <span className={t7} {...t8}>{message}</span>;
        break bb0;
      }
      if (shouldShowCount) {
        const t7 = cn("block text-right", messageClass);
        let t8;
        if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
          t8 = createDataAttributes({
            test: "count"
          });
          $[18] = t8;
        } else {
          t8 = $[18];
        }
        t6 = <span className={t7} {...t8}>{countText}</span>;
        break bb0;
      }
    }
    $[0] = countText;
    $[1] = customStyle?.message;
    $[2] = error;
    $[3] = length;
    $[4] = maxLength;
    $[5] = message;
    $[6] = showMaxLength;
    $[7] = theme;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
};